import { render, staticRenderFns } from "./FormLoginWrapper.vue?vue&type=template&id=2821f1b2&scoped=true&"
import script from "./FormLoginWrapper.vue?vue&type=script&lang=js&"
export * from "./FormLoginWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FormLoginWrapper.vue?vue&type=style&index=0&id=2821f1b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2821f1b2",
  null
  
)

export default component.exports